import { useMutation } from '@tanstack/react-query';

import type { LinePayload } from '../common/payload.types';
import type { PaymentTerm } from '../common/types';
import type { InvoiceTemplateInterval } from './types';

import { apiResourceSchema, previewHtmlSchema } from '../common/schemas';
import { fetchJson } from '../fetch';

export type Payload = {
  brandId: number | null;
  clientContactId: number | null;
  clientId: number | null;
  clientReference: string | null;
  conditionId: number | null;
  customAgreementId: number | null;
  customConditionId: number | null;
  description: string | null;
  interval: InvoiceTemplateInterval | null;
  lines: LinePayload[];
  nextInvoiceAt: string | null;
  numberingSeriesId: number | null;
  paymentTerm: PaymentTerm;
  paymentTermEndOfMonth: boolean;
  specialConditions: string | null;
  title: string | null;
};

export const usePreviewInvoiceTemplate = () => {
  return useMutation({
    mutationFn: async (body: Payload) => {
      const {
        data: { html },
      } = await fetchJson('/invoice-templates/preview', {
        method: 'POST',
        schema: apiResourceSchema(previewHtmlSchema),
        body,
      });

      return html;
    },
  });
};
